import { adminConsole } from './adminConsole';

// Keep this as the FIRST entry-point import, before React, MSAL and the store.
// Dependencies that capture a console method will capture the guarded version.
adminConsole.install();
